/*jshint scripturl:true*/
$(document).ready(function() {
    // SlideShow
    if ($("#ttgSlider").length) {
        $('.ttgImgGroup').each(function(i) {
            $(this).attr('rel', 'ttgImgGroup');
        });

        loadCarouFredSel();
    }

    // Seminarraum-Bildergalerie
    $(".ttgSeminarraumBilderGalerieIcon").click(function() {
        $(this).next().children().children().trigger("click");
    });

    // BILDERGALERIE TTG News Lightbox
    if ($("#ttgDetailSiteCarousel.carousel").length) {
        var nextElement = $("#ttgDetailSiteCarousel").data("next");
        var previousElement = $("#ttgDetailSiteCarousel").data("prev");
        var close = $("#ttgDetailSiteCarousel").data("close");

        $(document).on('click', '[data-toggle="lightbox"]', function(event) {
            event.preventDefault();
            var element = $(this);
            $(this).ekkoLightbox({
                leftArrow: "<span class=\"icon prev\"><span class='fas fa-angle-left' aria-hidden='true'></span><p class='sr-only'>" + previousElement + "</p></span>",
                rightArrow: "<span class=\"icon next\"><span class='fas fa-angle-right' aria-hidden='true'></span><p class='sr-only'>" + nextElement + "</p></span>",
                wrapping: 0,
                alwaysShowClose: true,
                onShown: function() {
                    $(".ekko-lightbox").attr("aria-modal", true);
                    $(".ekko-lightbox-nav-overlay a").attr("role", "button");
                    $(".ekko-lightbox .close").html('<span class="fas fa-times" aria-hidden="true"></span><span class="sr-only">' + close + '</span>').removeAttr("aria-label");
                },
                onHidden: function() {
                    element.focus();
                },
            });
        });
    }

    /* BOOTSTRAP CAROUSEL - Klick auf Lupensymbol soll die Lightbox öffnen */
    $('.ttgBildergalerieLupeBootstrapCarousel').click(function() {

        if ($(this).hasClass('ttgBildergalerieLupeBootstrapCarouselHoehenprofil')) {
            $(this).next().find('a').trigger('click');
            openDialog('lightbox', $(this));
            return;
        }
        if ($('#ttgDetailSiteCarousel').length) {
            $('#ttgDetailSiteCarousel').find('.active a').trigger('click');
        } else if ($('#ttgGewinnspielCarousel').length) {
            $('#ttgGewinnspielCarousel').find('.active a').trigger('click');
        } else if ($('.ttgTourdataDetailseite .carousel').length) {
            $('.ttgTourdataDetailseite .carousel').find('.active a').trigger('click');
        }
    });

    $('.ttgBildergalerieLupe360Panorama').hover(function() {
        $(this).parents().eq(2).find('.ttgBildergalerieLupeBootstrapCarousel').toggleClass('ttgBildergalerieLupeBootstrapCarouselHover');
    });
    $('.ttgBildergalerieLupeBootstrapCarousel').hover(function() {
        $(this).parent().find('.ttgBildergalerieLupe360Panorama').toggleClass('ttgBildergalerieLupe360PanoramaHover');
    });

    /* BOOTSTRAP CAROUSEL - sofern das nächste Element ein Video ist (Klasse ttgDoNotShowMagnifyingGlass), soll die Lupe ausgeblendet werden */
    $('.ttgSlideShowBootstrapDots, .carousel-control').click(function() {
        setTimeout(function() {
            if ($('.ttgSlideShowBootstrapInner .active').hasClass('ttgDoNotShowMagnifyingGlass')) {
                $('.ttgBildergalerieLupeBootstrapCarousel').hide();
            } else {
                $('.ttgBildergalerieLupeBootstrapCarousel').show();
            }
        }, 1000);
    });

    /* TT-News - 1. Item auf "active" setzen */
    $('#ttgTTNewsCarousel .ttgSlideShowBootstrapInner .item').first().addClass('active');

    /* TT-News - Dots erzeugen */
    if ($('#ttgTTNewsCarousel').length) {
        var anzahlItems = $('.item').length;
        var counter = 0;
        var dotHTML = '';

        while (counter < anzahlItems) {
            dotHTML += '<li data-target="#ttgTTNewsCarousel" data-slide-to="' + counter + '"></li>';
            counter++;
        } // while

        // HTML einfügen
        $(dotHTML).appendTo('.ttgSlideShowBootstrapDots');

        // Den 1. Dot als aktiv markieren
        $('#ttgTTNewsCarousel .ttgSlideShowBootstrapDots li').first().addClass('active');
    }

    /* TT-News - Pfeile verstecken, sofern keine Bilder eingefügt worden sind */
    if ($('#ttgTTNewsCarousel .ttgSlideShowBootstrapInner .item').length < 2) {
        $('#ttgTTNewsCarousel .carousel-control').hide();
        $('#ttgTTNewsCarousel .ttgSlideShowBootstrapDots').hide();
    }

    /* SWIPE ermöglichen */
    $(".carousel-inner").swipe({
        //Generic swipe handler for all directions
        swipeLeft: function(event, direction, distance, duration, fingerCount) {
            $(this).parent().carousel('next');
        },
        swipeRight: function() {
            $(this).parent().carousel('prev');
        },
        //Default is 75px, set to 0 for demo so any distance triggers swipe
        threshold: 35
    });

    /* Webcams - Klick auf Lupensymbol soll die Lightbox öffnen */
    $('#ttgWebcamLupe').click(function() {
        $(this).next().children('#ttgWebCamImageDefaultLink').trigger("click");
    });

    // 360° Text Info auch klickbar machen -> Modal soll sich öffnen
    if ($(".ttgBildergalerieLupe360Panorama").length) {
        $("body").on("click", ".ttgBildergalerieLupe360Panorama", function() {
            $(this).next().trigger("click");
        });
    }

    // Höhenprofil soll aber einer Breite unterhalb von 768 Pixel nicht mehr n einem Modal geöffnet werden können
    $("body").on("click", ".ttgHoehenprofilModalLink", function(e) {
        e.preventDefault();
        if ($(window).width() > 767) {
            openDialog("ttgHoehenprofilModal", $(this), $("#ttgHoehenprofilModal .close"));
        }
    });

    $("body").on("click", "#ttgHoehenprofilModal .close", function(e) {
        aria.getCurrentDialog().close();
    });

    $('body').on('keydown', '#ttgHoehenprofilModal', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $('#ttgHoehenprofilModal .close').click();
        }
    });

    $(window).resize(function() {
        if ($(window).width() <= 767) {
            $(".ttgHoehenprofilModalLink").css("cursor", "default");
            $(".ttgHoehenprofilModalLink").removeAttr("data-toggle");
            $("#ttgHoehenprofilModal").attr("aria-hidden", "true");
        } else {
            $(".ttgHoehenprofilModalLink").css("cursor", "pointer");
            $("#ttgHoehenprofilModal").removeAttr("aria-hidden");
        }
    });

    // Copyright Bilder
    $(document).on('click', '.ttgCopyright', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).children('.ttgCopyrightIcon ').is(":visible")) {
            $(this).children('.ttgCopyrightIcon ').hide();
            $(this).children('.ttgCopyrightText').show();
            $(this).children('.ttgCopyrightText').children('button').focus();
        } else {
            $(this).children('.ttgCopyrightIcon').show();
            $(this).children('.ttgCopyrightText').hide();
            $(this).children('.ttgCopyrightIcon').focus();
        }
        return false;
    });

    // TTG-Notification - Touch auf Mobilgeräten
    // Copyright Bilder
    $(document).on('click', '.ttg-notifications', function(e) {
        e.preventDefault();
        e.stopPropagation();

        return false;
    });
});


function loadCarouFredSel() {

    // Galerie nur erstellen, wenn mehr als ein Bild verfügbar ist
    if ($('#ttgSlider').children().length >= 2) {
        // Galerie minimal verspätet erstellen
        setTimeout(function() {
            // Using custom configuration

            $("#ttgSlider").carouFredSel({
                circular: true,
                infinite: true,
                responsive: true,
                direction: "right",
                width: "100%",
                height: "variable",
                items: {
                    height: "variable",
                },
                auto: false,
                scroll: {
                    items: "page",
                    easing: "swing",
                    duration: 500,
                    pauseOnHover: true
                },
                swipe: {
                    onTouch: true,
                    onMouse: true,
                    onAfter: function() {
                        $('.ttgImageSliderSwipeGesture').fadeOut('slow');
                    }
                },
                prev: {
                    button: "#ttgSlideShowPrev",
                    key: "left"
                },
                next: {
                    button: "#ttgSlideShowNext",
                    key: "right"
                },
                pagination: "#ttgPaginationDots"
            });
        }, 1500);
    } else {
        // wenn nur ein Bild vorhanden -> Swipe Gesture + Navigationspfeile entfernen
        $('.ttgImageSliderSwipeGesture').remove();
        $('.ttgPrevNextBtn').remove();
        $("#ttgSlider a").addClass("ttgBilderGalerieOnlyOneImage");
    }
}

$(window).resize(function() {

    if ($("#ttgSlider").length) {
        loadCarouFredSel();
    }

    // TOURDATA-Detailseite: Höhe des Videos anpassen
    if ($('.ttgSlideShowBootstrapInner').length) {
        var imgHeight = $('.ttgSlideShowBootstrapInner .item.active').height();
        var videoHeight = imgHeight;

        $('.ttgIframeVideoInImageGallery').css({
            'height': videoHeight
        });
    }

});

function lazyIMGheightFix() {

    var width = $(window).width();
    var width2ColPic = 750;
    var width1ColPic = 360;
    var specialHeight;

    if (width < 768) {
        /* console.log('xs'); */
        width2ColPic = width;
        width1ColPic = width;
        specialHeight = width1ColPic * 1.354;
    } else if (width >= 768 && width < 992) {
        /* console.log('sm'); */
        width2ColPic = 720;
        width1ColPic = 720;
        specialHeight = width1ColPic * 1.354;
    } else if (width >= 992 && width < 1200) {
        /* console.log('md'); */
        width2ColPic = 617;
        width1ColPic = 293;
    } else {
        /* console.log('lg'); */
    }
    var height2ColPic = (width2ColPic / 16) * 9;
    var height1ColPic = (width1ColPic / 16) * 9;

    /* 2 Cols Magic */
    $.each($('.col-md-8 .ttgNCEBildSingle:not(".hidden-md") > picture'), function() {
        $(this).closest('.ttgNCEBildSingle').css({
            'height': height2ColPic,
            'width': width2ColPic
        });
    });
    $.each($('.col-md-8 .ttgNCEVideoPreview > img'), function() {
        $(this).closest('.ttgNCEVideoPreview').css({
            'height': height2ColPic,
            'width': width2ColPic
        });
    });

    /* 1 Col Magic */
    $.each($('.col-md-4 .ttgNCEBildSingle:not(".hidden-md") > picture'), function() {
        $(this).closest('.ttgNCEBildSingle').css({
            'height': height1ColPic,
            'width': width1ColPic
        });
    });
    $.each($('.col-md-4 .ttgNCEVideoPreview > img'), function() {
        $(this).closest('.ttgNCEVideoPreview').css({
            'height': height1ColPic,
            'width': width1ColPic
        });
    });

    /* Specialheight */
    $.each($('.ttgNCEBildSingle.hidden-md > picture'), function() {
        $(this).closest('.ttgNCEBildSingle').css({
            'height': specialHeight,
            'width': width1ColPic
        });
    });

    console.log('lazyIMGheightFix');
}